import { useState, useCallback } from 'react';

/**
 * Custom hook to manage necklace expansion state
 * Ensures only one necklace can be expanded at a time
 */
export const useNecklaceExpansion = () => {
  const [expandedScale, setExpandedScale] = useState(null);

  const toggleNecklace = useCallback((scaleNumber) => {
    setExpandedScale(current => 
      current === scaleNumber ? null : scaleNumber
    );
  }, []); // Remove expandedScale dependency to avoid stale closures

  const isExpanded = useCallback((scaleNumber) => {
    return expandedScale === scaleNumber;
  }, [expandedScale]);

  return {
    toggleNecklace,
    isExpanded,
    expandedScale
  };
};